$(() => {
    // Клик по кнопке "показать в хедере в главном телефоне"
    function clickOnShowBtn(e) {
        const targetEl = $(e.target).hasClass("hide")
            ? e.target
            : $(e.target).closest(".hide");

        console.log("click show phone", targetEl);

        if ($(targetEl).hasClass("hide")) {
            e.preventDefault();
            e.stopPropagation();

            $(targetEl).find(".phone-show__btn-footer").remove();
            $(targetEl).removeClass("hide");
        }
    }

    // Мы сделали запрос в гео, и нам надо поменять телефон в хедере.
    // Для того, чтобы кнопка "показать не исчезла", мы клонируем её из
    // источника и потом добавляем обратно к элементу, после замены номера
    let mainPhoneContainer = $(".phone-select");
    let phoneLink = mainPhoneContainer.find(".phone");
    var showBtn = phoneLink.find(".phone-show__btn-footer").clone();

    if (window.lang && lang === "ru") {
        // $.get("/geo-city/", {}, function (data) {
        //     if (data.selected) {
        //         mainPhoneContainer.find(".country").text(data.selected.name);

        //         phoneLink.attr("href", "tel:" + data.selected.link);
        //         phoneLink.html(data.selected.phone);

        //         phoneLink.append(showBtn);
        //     }
        //     console.log("clickOnShowBtn click main language");
        //     phoneLink.on("click", clickOnShowBtn);
        // });
    } else {
        console.log("clickOnShowBtn click other language");
        phoneLink.on("click", clickOnShowBtn);
    }
});
